import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import '../css/trimmis.scss';

class ListOfProductsBlue extends Component {

  render() {

    const items = [
      {
        product: "Kynsien leikkuu",
        price: "19-39€"
      },
      {
        product: "Tassujen hoito",
        price: "19-39€"
      },
      {
        product: "Korvahoito",
        price: "19-39€"
      },
      {
        product: "Pennun harjoituskäynti",
        price: "19-39€"
      },
      {
        product: "Pesupaketti",
        price: "19-39€"
      },
      {
        product: "Ajelu",
        price: "19-39€"
      },
      {
        product: "Lyhyeksi muotoilu",
        price: "19-39€"
      },
      {
        product: "Ylläpitotrimmaus",
        price: "19-39€"
      },
      {
        product: "Rodunomainen trimmaus",
        price: "19-39€"
      },
      {
        product: "Senioirikäynti",
        price: "19-39€"
      },
      {
        product: "Muu pavelu",
        price: "19-39€"
      },
      {
        product: "Ensitarkastus",
        price: "19-39€"
      }
    ];

    const styles = {
      padding: 0
    };

    /* Might need to add one item to one component, but for now lets go with this. */

    return (
        <div className="trimmis-blue-card">
          <h2 className="trimmis-blue-card-title">{this.props.title}</h2>
          {items.map(function(item, i){
            return <div className="col-sm-2 col-xs-6" style={styles} key={i} >
              <div className="trimmis-blue-card-item"><div className="trimmis-blue-card-text-detail">{item.product}</div><span className="trimmis-blue-card-price-detail">{item.price}</span></div>
            </div>;
          })}
          <div className="clearfix"></div>
        </div>
    );
  }
}

export default ListOfProductsBlue;


// WEBPACK FOOTER //
// ../components/ListOfProductsBlue.js